import { render } from "./YRichtext.vue?vue&type=template&id=05d3240d&scoped=true"
import script from "./YRichtext.vue?vue&type=script&lang=js"
export * from "./YRichtext.vue?vue&type=script&lang=js"

import "./YRichtext.vue?vue&type=style&index=0&id=05d3240d&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d3240d"]])

export default __exports__